'use strict';

// key是sys_config_value表中的CONFIG_TYPE sys.authorized.key字串中包含的值
// sys.authorized.key是json格式, 解構後會使用到的對應key是exclude_auth_module
// value必須包在陣列中 用大寫的funCode
// 有在此設定的module為[不顯示], 沒有設定視為[顯示]
// 會直接影響所有被AuthModuleWrapper包起來的Routes以及權限設定的選項
// 會對Routes以外影響的參數, 統一在參數名前加上其他字串辨識, 例如Portal_XXXX

module.exports = Object.freeze({
  CE: ['EP20140', 'CE10010', 'CE10020', 'CE20010', 'CE20020', 'M410121'],
  WFCUST: ['EP20140'],
  EP: [
    'EP',
    'EP20110',
    'EP20120',
    'EP20130',
    'EP20140',
    'EP20210',
    'EP20230',
    'EP20310',
    'EP20320',
    'EP30110',
    'EP30120',
    'EP30130',
    'EP30220',
    'EP30240',
    'EP40110',
    'EP40130',
    'EP50110',
    'EP80110',
    'EP80210',
    'EP80220',
    'EP80230',
    'EP80240',
    'EP90170',
    'EP90130',
    'EP90140',
    'EP90150',
    'M5',
    'M510010',
    'M510010',
    'M510020',
    'M510030',
    'M510031',
    'M510040',
    'M510050',
    'M510060',
    'Portal_WF',
  ],
  WF: [
    'EP2',
    'EP20110',
    'EP20120',
    'EP20130',
    'EP20140',
    'EP20210',
    'EP20230',
    'EP20310',
    'EP20320',
    'M5',
    'M510010',
    'M510010',
    'M510020',
    'M510030',
    'M510031',
    'M510040',
    'M510050',
    'M510060',
    'Portal_WF',
  ],
  MP: ['SYS30050'],
});
